import { render, staticRenderFns } from "./ViewExpense.vue?vue&type=template&id=26167a2e&"
import script from "./ViewExpense.vue?vue&type=script&lang=js&"
export * from "./ViewExpense.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports